import { PROCESSING } from "http-status-codes";

/**
 * State for objects like the Q Round as a whole. This provides for draft->active, and for archive as an alternative to delete.
 * See the LifecycleState.java
 */
const LifecycleState = Object.freeze({
  /**
	 * Created but not yet open - most people cannot access (even if some of the questions are ready). 

	 * Aka `started` though that is a bit of a confusing label (e.g. "Has the round started yet?" "Yes but no you can't see it") 
	 */
  DRAFT: "DRAFT",

  /**
   * Aka `open` - the main stage.
   */
  ACTIVE: "ACTIVE",

  /**
   * No edits allowed, but still visible
   */
  CLOSED: "CLOSED",

  /**
   * Like deleted, but still in the database
   */
  ARCHIVED: "ARCHIVED",

  /**
   * A special state for computer-at-work
   */
  PROCESSING: "PROCESSING",

  ERROR: "ERROR",

  /**
   * A special state for query methods. This is never saved.
   */
  FIND_NOT_ARCHIVED: "FIND_NOT_ARCHIVED",

  /**
   * A special state for query methods. This is never saved.
   */
  FIND_ALL: "FIND_ALL",
});
export default LifecycleState;
